<div class="input-group">
  <button class="form-control form-control-display text-start" type="button" [disabled]="disabled || !productId || !locationId" (click)="show()">
    {{ selected?.reference_number || (value ? 'Saved item unavailable' : placeholder) }}
  </button>
  <button *ngIf="selected && !disabled" class="btn" type="button" (click)="clear()">Clear</button>
</div>
<small class="form-hint" *ngIf="!productId">Select a product first.</small>
<small class="form-hint" *ngIf="productId && !locationId">Select a location or warehouse first.</small>
<small class="text-danger d-block" role="status" *ngIf="loadError">{{ loadError }}</small>

<div class="modal d-block" *ngIf="open" tabindex="-1" role="dialog" aria-modal="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable"><div class="modal-content">
    <div class="modal-header"><h3 class="modal-title">Select Product Item</h3><button type="button" class="btn-close" (click)="close()"></button></div>
    <div class="modal-body">
      <input class="form-control form-control-display mb-3" [(ngModel)]="search" [ngModelOptions]="{standalone: true}" placeholder="Search reference or attributes" />
      <div class="list-group">
        <button type="button" class="list-group-item list-group-item-action d-flex align-items-center gap-3" *ngFor="let item of filteredItems" (click)="choose(item)">
          <img *ngIf="imageUrl(item) as resolvedImage" [src]="resolvedImage" class="item-image rounded" alt="" />
          <span><strong>{{ item.reference_number }}</strong><small class="d-block text-secondary">{{ item.attribute_values | json }}</small></span>
          <span class="badge bg-primary-lt text-primary ms-auto">{{ item.status }}</span>
        </button>
        <div class="text-center text-secondary p-4" *ngIf="!loading && filteredItems.length === 0">No available items match this search.</div>
      </div>
    </div>
  </div></div>
</div><div class="modal-backdrop fade show" *ngIf="open"></div>
